import {combineReducers} from 'redux';
import newsReducer from '../pages/news/services/reducer';
import newsGroup from '../pages/news-group/services/reducer';
import newsEditGroup from '../pages/news-group-edit/services/reducer';
import newEditReducer from '../pages/news-edit/services/reducer';
import equipmentsReducer from '../pages/equipments/services/reducer';
import equipmentsEditReducer from '../pages/equipment-edit/services/reducer';
import categoriesReducer from '../pages/categories/services/reducer';
import categoryEditReducer from '../pages/category-edit/services/reducer';
import interfacesReducer from '../pages/interfaces/services/reducer';
import interfacesEditReducer from '../pages/interfaces-edit/services/reducer';
import technologyReducer from '../pages/technologies/services/reducer';
import technologyEditReducer from '../pages/technology-edit/services/reducer';
import typesReducer from '../pages/types/services/reducer';
import typesEditReducer from '../pages/type-edit/services/reducer';
import vendorsReducer from '../pages/vendors/services/reducer';
import vendorsEditReducer from '../pages/vendor-edit/services/reducer';
import currenciesReducer from '../pages/currencies/services/reducer';
import currenciesEditReducer from '../pages/currencies-edit/services/reducer';
import softwareReducer from '../pages/software/services/reducer';
import softwareEditReducer from '../pages/software-edit/services/reducer';
import pagesReducer from '../pages/pages-front/services/reducer';
import pagesEditReducer from '../pages/pages-front-edit/services/reducer';
import pagesMedia from '../pages/media/services/reducer';
import pagesMediaAssembling from '../pages/media-assembling/services/reducer';
import pagesTestimonials from '../pages/testimonials/services/reducer';
import pagesEditTestimonials from '../pages/testimonials-edit/services/reducer';
import pagesSolutions from '../pages/pages-solutions/services/reducer';
import pagesSolutionsEdit from '../pages/pages-solution-edit/services/reducer';

const rootReducer = combineReducers({
    newsReducer,
    newsGroup,
    newsEditGroup,
    newEditReducer,
    equipmentsReducer,
    equipmentsEditReducer,
    categoriesReducer,
    categoryEditReducer,
    interfacesReducer,
    interfacesEditReducer,
    technologyReducer,
    technologyEditReducer,
    typesReducer,
    typesEditReducer,
    vendorsReducer,
    vendorsEditReducer,
    softwareReducer,
    softwareEditReducer,
    currenciesReducer,
    currenciesEditReducer,
    pagesReducer,
    pagesEditReducer,
    pagesMedia,
    pagesMediaAssembling,
    pagesTestimonials,
    pagesEditTestimonials,
    pagesSolutions,
    pagesSolutionsEdit
});


export default rootReducer;
